module.exports = __webpack_public_path__ + "img/indu_4.d4d718fd.png";